export default function TitleView({ title }) {
  return <div className="songsPlatformTitle">{title}</div>;
}
